// extracted by mini-css-extract-plugin
export default {"CreateNewProfileButtonMobile":"Profiles_CreateNewProfileButtonMobile__Ssm0B","Content":"Profiles_Content__dHTtu"};